import { RouterProvider } from "@tanstack/react-router";
import { router } from "@/Router.tsx";
import { Toaster } from "@/components/ui/sonner.tsx";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/store/queryConfig.ts";
import { OfflineOverlay } from "@/components/OfflineOverlay.tsx";
import { EasterEggGate } from "@/components/easter-egg/EasterEggGate.tsx";
import { Snowflake } from "@/components/Snowflake.tsx";

export default function App() {
    window.triggerError = () => {
        throw Error("Manually triggered error for testing purposes");
    };

    return (
        <>
            <QueryClientProvider client={queryClient}>
                <Snowflake />
                <EasterEggGate />
                <RouterProvider router={router} />
                <OfflineOverlay />
                <Toaster
                    position="bottom-right"
                    expand
                    richColors
                    closeButton
                />
            </QueryClientProvider>
        </>
    );
}
